import { render } from "./MedioPers.vue?vue&type=template&id=5c64edfa&scoped=true"
import script from "./MedioPers.vue?vue&type=script&lang=js"
export * from "./MedioPers.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=5c64edfa&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c64edfa"]])

export default __exports__